/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/goal_medium'
export default icon
